jQuery(document).ready(function ($) {

    AOS.init();

    setTimeout(function () {
        AOS.init({
            once: true,
            duration: 300,
            delay: 0
        });
    }, 100);

    jQuery("a[href='#']").attr("href", "javascript:void(0)");

    $("#StartNodeId").on('change', function () {
        var count = $("#StartNodeId option:selected").attr("data-id");
        $(".search-node-field").val(count);
    });

    var count = $("#StartNodeId option:selected").attr("data-id");
    $(".search-node-field").val(count);

    $(".site-navigation-toggle").click(function () {
        $('.site-header').toggleClass("menu_active");
        $('body').toggleClass("toggle_menu_active");
        if ($('body').hasClass("toggle_search_active")) {
            $('.site-header').removeClass("search_active");
            $('body').removeClass("toggle_search_active");
            $('.site-search').slideUp();
        }
        if ($('nav.primary-navigation li.menu-item-has-children').hasClass("open")) {
            $('nav.primary-navigation li.menu-item-has-children button.submenu-toggle').removeClass("active");
            $('nav.primary-navigation li.menu-item-has-children').removeClass("open");
            $('nav.primary-navigation li.menu-item-has-children .sub-menu').slideUp();
        }
    });

    $(".site-search-toggle").click(function () {
        $('.site-header').toggleClass("search_active");
        $('body').toggleClass("toggle_search_active");
        $('.site-search').slideToggle();
        if ($('body').hasClass("toggle_menu_active")) {
            $('.site-header').removeClass("menu_active");
            $('body').removeClass("toggle_menu_active");
        }
    });

    $('body').on('click', 'nav.primary-navigation li.menu-item-has-children > a', function (e) {
        // if ($(window).width() < 992) {
        e.preventDefault();
        $(this).parent().siblings().find('> a').removeClass("active");
        $(this).parent().siblings().find('> a').parent().find('> .sub-menu').slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().find('> .sub-menu').slideToggle().parent().toggleClass('open');
        // }
    });

    const header = document.querySelector(".site-header");
    const toggleClass = "sticky";

    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 250) {
            header.classList.add(toggleClass);
            jQuery("body").addClass('sticky-enabled')
        } else {
            header.classList.remove(toggleClass);
            jQuery("body").removeClass('sticky-enabled')
        }
    }, );

    var headerHeight = $('.site-header').outerHeight();
    if (!jQuery("body").hasClass("home")) {
        headerHeight = $('.site-header').outerHeight() + 50;
    }
    $('.site-content').css('margin-top', headerHeight);


    $(".testimonial_sec").each(function (index) {
        let slide = $(this).find('.testimonial_list__item');
        let slider = $(this).find('.testimonial_list');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                prevArrow: $(this).find('.prev-arrow'),
                nextArrow: $(this).find('.next-arrow'),
            });
        }
    });

    jQuery('#wppb-login-wrap #user_login').attr("placeholder", "Username or Email");
    jQuery('#wppb-login-wrap #user_pass').attr("placeholder", "Password");

    offsetLeft();

    $("body").on("focus", ".form .gform_wrapper .gfield.absoluteLabel input", function (event) {
        jQuery(this).parent().parent().addClass('active');
    });
    $("body").on("blur", ".form .gform_wrapper .gfield.absoluteLabel input", function (event) {
        if (jQuery(this).val() == '') {
            jQuery(this).parent().parent().removeClass('active');
        }
    });
    jQuery(".form .gform_wrapper .gfield.absoluteLabel input").each(function (index) {
        jQuery(this).trigger("blur");
    });

    $(document).ajaxComplete(function () {
        jQuery(".form .gform_wrapper .gfield.absoluteLabel input").each(function (index) {
            jQuery(this).trigger("focus");
        });
    });
    $(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".form .gform_wrapper .gfield.absoluteLabel input").each(function (index) {
            jQuery(this).trigger("focus");
        });
    });

    $('.js-select-office').select2({
        placeholder: 'Select an office',
        dropdownPosition: 'below'
    });

    $("form#office-search").on("submit", function (event) {
        event.preventDefault();
        let url = $('form > .js-select-office').val();
        window.location.href = url;
    });

    var locHash = window.location.hash;
    if (locHash != undefined && locHash != "" && locHash != null) {
        if (jQuery(locHash + "_scroll").length > 0) {
            jQuery("body, html").animate({
                scrollTop: jQuery(locHash + "_scroll").offset().top - 180
            }, 1000);
        }
    }
    jQuery("a[href*=#]:not([data-lity])").on("click", function (e) {
        e.preventDefault();
        var link1 = jQuery(this).attr("href");
        var target1 = jQuery(this).attr("target");
        if (target1 == undefined || target1 == null || target1 == "") {
            target1 = "_self";
        }
        if (link1.indexOf("#") > -1) {
            var link1Arr = link1.split('#');
            if (link1Arr.length > 1) {
                var linkId = link1Arr[1];
                if (jQuery("#" + linkId + "_scroll").length > 0) {
                    jQuery("body, html").animate({
                        scrollTop: jQuery("#" + linkId + "_scroll").offset().top - 180
                    }, 1000);
                } else {
                    window.open(link1, target1);
                }
            } else {
                window.open(link1, target1);
            }
        } else {
            window.open(link1, target1);
        }
    })

    jQuery(window).resize(function (jQuery) {
        var headerHeight = $('.site-header').outerHeight();
        $('.site-content').css('margin-top', headerHeight);
    });

    jQuery(".form_custom_autocomplete input").on("keyup input touchend tap", function (event) {
        var value1 = jQuery(this).val();
        if (value1.length >= 4) {
            jQuery(this).parent().find(".search_courses_autocomplete").addClass("show");
        } else {
            jQuery(this).parent().find(".search_courses_autocomplete").removeClass("show");
        }
        if (value1 != "") {
            value1 = value1.toLowerCase();
            jQuery(this).parent().find(".search_courses_autocomplete li").each(function () {
                var text1 = jQuery(this).text();
                text1 = text1.toLowerCase();
                if (text1.indexOf(value1) > -1) {
                    jQuery(this).show();
                } else {
                    jQuery(this).hide();
                }
            })
            if (jQuery(this).parent().find(".search_courses_autocomplete li:visible").length == 0) {
                jQuery(this).parent().find(".search_courses_autocomplete").removeClass("show");
            } else {
                if (value1.length >= 4) {
					jQuery(item).parent().find(".search_courses_autocomplete").addClass("show");
				} else {
					jQuery(item).parent().find(".search_courses_autocomplete").removeClass("show");
				}
            }
        } else {
            jQuery(this).parent().find(".search_courses_autocomplete li").show();
        }
    });

    jQuery(document).on("click", ".search_courses_autocomplete li", function () {
        var text1 = jQuery(this).text();
        jQuery(this).closest(".form_custom_autocomplete").find("input").val(text1);
    })

    jQuery(".form_custom_autocomplete input").on("blur", function () {
        var item1 = this;
        setTimeout(function () {
            var value1 = jQuery(this).val();
            if (value1.length >= 4) {
                jQuery(this).parent().find(".search_courses_autocomplete").addClass("show");
            } else {
                jQuery(this).parent().find(".search_courses_autocomplete").removeClass("show");
            }
        }, 300);
    })

})

function offsetLeft() {
    if (jQuery(window).width() < 992) {
        if ((jQuery('.site-header-inner').length > 0)) {
            var boxesoffset = jQuery('.site-header-inner').offset(),
                boxeswindWidth = jQuery(window).width();
            jQuery('.site-header-inner').css('width', (boxeswindWidth - boxesoffset.left));
        }
    } else {
        jQuery('.site-header-inner').removeAttr("style");
    }
}

jQuery(window).resize(function (jQuery) {
    offsetLeft();
});

jQuery(window).load(function () {
    offsetLeft();
});